var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.subtotal >= 5000
    ? _c(
        "div",
        {
          staticClass: "conversion-stripe conversion-stripe--rfp",
          attrs: { id: "tarjouspyynto" }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "conversion-stripe__container conversion-stripe__container--rfp"
            },
            [
              _c(
                "p",
                {
                  staticClass:
                    "conversion-stripe__heading conversion-stripe--rfp__heading"
                },
                [_vm._v("\n      " + _vm._s(_vm.conversion.heading) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass:
                    "conversion-stripe__text conversion-stripe--rfp__text"
                },
                [_vm._v("\n      " + _vm._s(_vm.conversion.text) + "\n    ")]
              ),
              _vm._v(" "),
              _c("input", {
                staticClass: "btn btn--block",
                attrs: {
                  type: "submit",
                  name: "offer_request_without_shipping"
                },
                domProps: { value: _vm.conversion.button_text },
                on: {
                  click: function($event) {
                    return _vm.submit()
                  }
                }
              })
            ]
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55c8ac26", { render: render, staticRenderFns: staticRenderFns })
  }
}